import { Navigate, useParams } from 'react-router-dom';
import ProtectedRoute from 'ProtectedRoute/ProtectedRoute';
import React from 'react';

type Props = {
  navigateTo: string;
};

const NavigationRoute = ({ navigateTo }: Props) => {
  const { healthDeclarationId } = useParams();

  if (!healthDeclarationId) {
    throw new Error('missing');
  }

  return (
    <ProtectedRoute>
      <Navigate
        to={`/${healthDeclarationId}/${navigateTo}`}
      />
    </ProtectedRoute>
  );
};

export default NavigationRoute;
